import api from './api';

const sessionService = {
  // Get all sessions
  getSessions: async () => {
    const response = await api.get('/sessions');
    return response.data;
  },
  
  // Get session by account ID
  getSession: async (id) => {
    const response = await api.get(`/sessions/${id}`);
    return response.data;
  },
  
  // Delete session files
  deleteSession: async (id) => {
    const response = await api.delete(`/sessions/${id}`);
    return response.data;
  },
  
  // Reset session (delete files and update account status)
  resetSession: async (id) => {
    const response = await api.post(`/sessions/${id}/reset`);
    return response.data;
  }
};

export default sessionService;
